export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5015.eb89e581.jpg";